import { render } from "./Specialties.vue?vue&type=template&id=6574ed8c&ts=true"
import script from "./Specialties.vue?vue&type=script&lang=ts"
export * from "./Specialties.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__